import { useBrand } from "../contexts/BrandContext/hooks";
import { getCachedBrandDetails } from "../contexts/BrandContext/cache";

export interface BrandIdentity {
  /** Brand display name, or null when not set yet. */
  name: string | null;
  /** Brand logo URL, or null when not uploaded (placeholder URLs count as none). */
  logo: string | null;
}

/**
 * The tenant brand's display identity for white-label UI. Works both inside
 * BrandProvider (live details) and above it (falls back to the module-level
 * cache, e.g. the auth-check loading screen).
 */
export function useBrandIdentity(): BrandIdentity {
  const { brandDetails } = useBrand();
  const details = brandDetails ?? getCachedBrandDetails();

  const name =
    (details?.companyName || details?.username || "").trim() || null;

  const rawLogo = details?.brandProfileImage;
  const logo =
    rawLogo && !rawLogo.includes("/placeholder/no-image") ? rawLogo : null;

  return { name, logo };
}
